import React__default from 'react';
import { Global, css } from '@emotion/react';

const ZinniaFonts = ({ children }) => {
  return React__default.createElement(
    React__default.Fragment,
    null,
    React__default.createElement(Global, { styles: css`
          @font-face {
            font-family: Degular Display;
            src: url('https://fonts.zapier.com/Degular/DegularDisplay-Medium.woff2')
              format('woff2');
            font-display: swap;
            font-weight: 500;
          }
          @font-face {
            font-family: Degular Display;
            src: url('https://fonts.zapier.com/Degular/DegularDisplay-Semibold.woff2')
              format('woff2');
            font-display: swap;
            font-weight: 600;
          }
          @font-face {
            font-family: Degular Display;
            src: url('https://fonts.zapier.com/Degular/Degular_Display-Bold.woff2')
              format('woff2');
            font-display: swap;
            font-weight: 700;
          }
        ` }),
    React__default.createElement("link", { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" }),
    children
  );
};

export { ZinniaFonts };
//# sourceMappingURL=ZinniaFonts.es.js.map
